module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/institutions/icon_star-ee41faf49150e5dde5b3b5340538335d.svg";